import { render, staticRenderFns } from "./NewBattery.vue?vue&type=template&id=0982e2b8&"
import script from "./NewBattery.vue?vue&type=script&lang=js&"
export * from "./NewBattery.vue?vue&type=script&lang=js&"
import style0 from "./NewBattery.vue?vue&type=style&index=0&id=0982e2b8&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports